import { render, staticRenderFns } from "./owner_admin_panel.vue?vue&type=template&id=75983200&scoped=true"
import script from "./owner_admin_panel.vue?vue&type=script&lang=js"
export * from "./owner_admin_panel.vue?vue&type=script&lang=js"
import style0 from "./owner_admin_panel.vue?vue&type=style&index=0&id=75983200&prod&lang=scss"
import style1 from "./owner_admin_panel.vue?vue&type=style&index=1&id=75983200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75983200",
  null
  
)

export default component.exports